import CalendarLocale from '@rc-component/picker/locale/ka_GE';
import TimePickerLocale from '../../time-picker/locale/ka_GE';
const locale = {
    lang: {
        placeholder: 'აირჩიეთ თარიღი',
        yearPlaceholder: 'აირჩიეთ წელი',
        quarterPlaceholder: 'აირჩიეთ მეოთხედი',
        monthPlaceholder: 'აირჩიეთ თვე',
        weekPlaceholder: 'აირჩიეთ კვირა',
        rangePlaceholder: ['საწყისი თარიღი', 'საბოლოო თარიღი'],
        rangeYearPlaceholder: ['საწყისი წელი', 'საბოლოო წელი'],
        rangeQuarterPlaceholder: ['საწყისი მეოთხედი', 'საბოლოო მეოთხედი'],
        rangeMonthPlaceholder: ['საწყისი თვე', 'საბოლოო თვე'],
        rangeWeekPlaceholder: ['საწყისი კვირა', 'საბოლოო კვირა'],
        ...CalendarLocale,
    },
    timePickerLocale: {
        ...TimePickerLocale,
    },
};
export default locale;
